import * as angular from 'angular';
import template from './modal-zoom-image.template.html';

export default {
  template,
  controller: 'ModalZoomImageController',
  controllerAs: '$ctrl',
  appendElement: angular.element(document.querySelector('app')),
};



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-zoom-image/modal-zoom-image.component.js